import { RESET_APP } from '../actions';
import {
  AWAIT_NAVIGATION,
  CANCEL_NAVIGATION,
  NAVIGATE_BACK,
  NAVIGATE_TO
} from '../actions/navigation';

export const AppStep = Object.freeze({
  Error: -99,
  Location: -100,
  Date: -101,
  Pay: -102,
  Checkout: -1,
  Sequence: -2,
  CustomBooking: -3,
  Station: 1,
  PartyRoom: 2,
});

const initialState = {
  currentStep: AppStep.Location,
  navigating: false,
  previousStep: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AWAIT_NAVIGATION:
      return {
        ...state,
        navigating: true,
      };
    case CANCEL_NAVIGATION:
      return {
        ...state,
        navigating: false,
      };
    case NAVIGATE_BACK:
      return {
        ...state,
        currentStep: state.currentStep - 1,
        navigating: false,
        previousStep: ''
      };
    case NAVIGATE_TO:
      return {
        ...state,
        currentStep: action.step,
        navigating: false,
        previousStep: state.currentStep,
      };
    case RESET_APP:
      return { ...initialState };
    default:
      return state;
  }
}
